import React from 'react'

const WritingStylesIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.5 9.99987H19V4.99987H16.5V7.61522H7.5V4.99987H4.99997V18.9999H11V20.4999H3.5V3.49989H9.71347C9.85194 3.01273 10.135 2.60889 10.5625 2.28839C10.9901 1.96788 11.4692 1.80762 12 1.80762C12.5513 1.80762 13.0381 1.96788 13.4606 2.28839C13.883 2.60889 14.1634 3.01273 14.3019 3.49989H20.5V9.99987ZM12.0017 5.11527C12.2582 5.11527 12.4727 5.02849 12.6452 4.85492C12.8176 4.68137 12.9039 4.46631 12.9039 4.20974C12.9039 3.95318 12.8171 3.73868 12.6435 3.56625C12.4699 3.39381 12.2549 3.30759 11.9983 3.30759C11.7418 3.30759 11.5273 3.39437 11.3548 3.56792C11.1824 3.74149 11.0962 3.95655 11.0962 4.21312C11.0962 4.46969 11.1829 4.68419 11.3565 4.85662C11.5301 5.02905 11.7451 5.11527 12.0017 5.11527Z"
                fill="white"
            />
            <path
                d="M18.7 11L17.4333 13.5333L14.9 14.8L17.4333 16.0667L18.7 18.6L19.9667 16.0667L22.5 14.8L19.9667 13.5333L18.7 11Z"
                fill="white"
            />
            <path
                d="M14.8998 16.6997L14.2665 17.9664L12.9998 18.5997L14.2665 19.233L14.8998 20.4997L15.5331 19.233L16.7998 18.5997L15.5331 17.9664L14.8998 16.6997Z"
                fill="white"
            />
        </svg>
    )
}

export default WritingStylesIcon
